<template>
  <div class="main">
    <div class="outer-container">
      <div class="back">
        <router-link to="./">back to list</router-link>
      </div>

      <h1>Nothing Was Found!</h1>
      <p class="text-center">This is so tragic. So so tragic.</p>
      <!-- <router-link to="/blog" style="text-decoration: underline;">back to list</router-link> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>
